// Shared numeric constants — single source of truth so the scene, overlay
// projections and camera defaults stay in sync.

export const EARTH_RADIUS = 1.0;
export const ATMOSPHERE_RADIUS = 1.025;
export const CAMERA_DISTANCE = 3.2;
export const MIN_CAMERA_DISTANCE = 1.25;
export const MAX_CAMERA_DISTANCE = 8.0;

// Local 4K textures served by Vite from the public/textures directory.
// Day: Planet Pixel Emporium "no clouds" — vivid, photographic, stronger
// greens over Europe/forests than NASA Blue Marble. Night + water masks
// sourced from the three-globe asset set. Physical: Natural Earth II
// hypsometric (HYP_50M_SR_W) downsampled from 10800×5400 → 4096×2048.
export const TEXTURE_DAY = "/textures/earth_day.jpg";
export const TEXTURE_NIGHT = "/textures/earth_night.jpg";
export const TEXTURE_WATER = "/textures/earth_water.png";
export const TEXTURE_PHYSICAL = "/textures/earth_physical.jpg";

/** Globe display modes. Each layer picks the day-side texture and
 *  whether real-time sun lighting (day/night blend) applies. */
export type LayerId = "satellite" | "timezones" | "physical" | "night";

export interface LayerDef {
  /** URL of the day-side texture. Swapped in at runtime via setLayer. */
  dayUrl: string;
  /** Flat = 1 turns off day/night blending — the chosen texture shows
   *  everywhere regardless of sun position (for atlas-like maps). */
  flat: 0 | 1;
  /** Vector = 1 draws a flat two-tone map (land / water from the water
   *  mask) instead of the photographic texture — the clean base under
   *  the Time zones overlays. */
  vector: 0 | 1;
  /** Zones = 1 paints each time zone's area in its own colour over
   *  the vector map, and brings the time-zone overlays: live boundary
   *  lines, country borders, terminator, zone cities. */
  zones: 0 | 1;
  label: string;
}

export const LAYERS: Record<LayerId, LayerDef> = {
  satellite: { dayUrl: TEXTURE_DAY,      flat: 0, vector: 0, zones: 0, label: "Satellite"  },
  timezones: { dayUrl: TEXTURE_DAY,      flat: 0, vector: 1, zones: 1, label: "Time zones" },
  physical:  { dayUrl: TEXTURE_PHYSICAL, flat: 1, vector: 0, zones: 0, label: "Physical"   },
  night:     { dayUrl: TEXTURE_NIGHT,    flat: 1, vector: 0, zones: 0, label: "Night"      },
};
